import React, { useCallback } from 'react';

import { AppButton } from 'src/components/AppButton/AppButton';
import { PENDING_EDITS } from 'src/constants/pendingEdtsConstants';

import './PendingEditsHeader.scss';

interface PendingEditsHeaderProps {
  approveRejectHandler: (status: PENDING_EDITS, reason: string) => void;
}

export const PendingEditsHeader: React.FC<PendingEditsHeaderProps> = ({ approveRejectHandler }) => {
  const approveRejectPendingEditsHandler = useCallback(
    (status, reason) => () => {
      approveRejectHandler(status, reason);
    },
    [approveRejectHandler],
  );

  return (
    <div className="hos-log__admin-edit-pending">
      <div className="hos-log__admin-edit-pending__text">
        <h5 className="title-h5">Admin Edit Pending</h5>
        <p>
          You have a pending admin edit to accept. Please review the changes and either accept or
          reject the changes.
        </p>
      </div>
      <div className="hos-log__admin-edit-pending__buttons">
        <AppButton
          title="Accept Edit"
          whiteBtn
          onClick={approveRejectPendingEditsHandler(PENDING_EDITS.APPROVE_EDIT, 'Approved by user')}
        />
        <AppButton
          title="Reject Edit"
          whiteBtn
          onClick={approveRejectPendingEditsHandler(PENDING_EDITS.REJECT_EDIT, 'Rejected by user')}
        />
      </div>
    </div>
  );
};
